module.exports = __webpack_public_path__ + "img/Abecedario_activo.648b1c3c.svg";